import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<span class="dirty-dot svelte-e4mkf1" title="未適用の変更があります" aria-label="変更あり">●</span>`);
var root_1 = $.from_html(`<button class="close-btn svelte-e4mkf1" type="button" title="タブを閉じる" aria-label="タブを閉じる">×</button>`);
var root_2 = $.from_html(`<div role="tab"><span class="tab-label svelte-e4mkf1"> </span> <!> <!></div>`);
var root_3 = $.from_html(`<div class="tab-bar svelte-e4mkf1" role="tablist"></div>`);

const $$css = {
	hash: 'svelte-e4mkf1',
	code: '.tab-bar.svelte-e4mkf1 {display:flex;flex-direction:row;align-items:stretch;gap:0;padding:0 8px;flex-shrink:0;overflow-x:auto;scrollbar-width:none;}.tab-bar.svelte-e4mkf1::-webkit-scrollbar {display:none;}.tab-btn.svelte-e4mkf1 {display:flex;align-items:center;gap:5px;padding:0 12px;height:34px;cursor:pointer;font-size:12px;font-weight:500;color:var(--color-muted);border-bottom:2px solid transparent;white-space:nowrap;user-select:none;position:relative;transition:color 0.1s, border-color 0.1s;}.tab-btn.svelte-e4mkf1:hover {color:var(--color-text);}.tab-btn.active.svelte-e4mkf1 {color:var(--color-text-strong);font-weight:600;border-bottom-color:var(--color-accent);}.tab-label.svelte-e4mkf1 {max-width:140px;overflow:hidden;text-overflow:ellipsis;}.dirty-dot.svelte-e4mkf1 {font-size:8px;color:var(--color-accent);line-height:1;}.close-btn.svelte-e4mkf1 {display:flex;align-items:center;justify-content:center;width:16px;height:16px;margin-left:2px;padding:0;border:none;border-radius:3px;background:transparent;color:var(--color-muted);font-size:13px;line-height:1;cursor:pointer;flex-shrink:0;}.close-btn.svelte-e4mkf1:hover {background:color-mix(in srgb, var(--color-line), transparent 40%);color:var(--color-text-strong);}'
};

export default function Svelte_pipeline_tab_bar($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const tabs = $.prop($$props, 'tabs', 23, () => []),
		activeTabId = $.prop($$props, 'activeTabId', 7, 'pipeline');

	function dispatch(name, detail) {
		$$props.$$host.dispatchEvent(new CustomEvent(name, { detail, bubbles: true, composed: true }));
	}

	var $$exports = {
		get tabs() {
			return tabs();
		},

		set tabs($$value = []) {
			tabs($$value);
			$.flush();
		},

		get activeTabId() {
			return activeTabId();
		},

		set activeTabId($$value = 'pipeline') {
			activeTabId($$value);
			$.flush();
		}
	};

	var div = root_3();

	$.each(div, 21, tabs, (tab) => tab.id, ($$anchor, tab) => {
		var div_1 = root_2();
		let classes;
		var span = $.child(div_1);
		var text = $.only_child(span, true);
		var node = $.sibling(span, 2);

		{
			var consequent = ($$anchor) => {
				var span_1 = root();

				$.append($$anchor, span_1);
			};

			$.if(node, ($$render) => {
				if ($.get(tab).isDirty) $$render(consequent);
			});
		}

		var node_1 = $.sibling(node, 2);

		{
			var consequent_1 = ($$anchor) => {
				var button = root_1();

				$.delegated('click', button, (e) => {
					e.stopPropagation();
					dispatch('tab-close-request', { tabId: $.get(tab).id });
				});

				$.append($$anchor, button);
			};

			$.if(node_1, ($$render) => {
				if ($.get(tab).kind === 'lut') $$render(consequent_1);
			});
		}

		$.reset(div_1);

		$.template_effect(() => {
			classes = $.set_class(div_1, 1, 'tab-btn svelte-e4mkf1', null, classes, { active: $.get(tab).id === activeTabId() });
			$.set_attribute(div_1, 'aria-selected', $.get(tab).id === activeTabId());
			$.set_attribute(div_1, 'tabindex', $.get(tab).id === activeTabId() ? 0 : -1);
			$.set_text(text, $.get(tab).label);
		});

		$.delegated('click', div_1, () => dispatch('tab-select', { tabId: $.get(tab).id }));

		$.delegated('keydown', div_1, (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				dispatch('tab-select', { tabId: $.get(tab).id });
			}
		});

		$.append($$anchor, div_1);
	});

	$.reset(div);
	$.append($$anchor, div);

	return $.pop($$exports);
}

$.delegate(['click', 'keydown']);
customElements.define('lut-pipeline-tab-bar', $.create_custom_element(Svelte_pipeline_tab_bar, { tabs: {}, activeTabId: {} }, [], []));